import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Path } from '../../PathBuilder/pathBuilderTypes';

interface PathSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  selectedPathName: string;
  setSelectedPathName: (name: string) => void;
  paths: Path[];
  pendingPathDrop: { code: string; targetLine: number } | null;
  onConfirm: () => void;
}

const PathSelectionDialog = ({
  open,
  onClose,
  selectedPathName,
  setSelectedPathName,
  paths,
  pendingPathDrop,
  onConfirm,
}: PathSelectionDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select a path</DialogTitle>
      <DialogContent>
        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
          <InputLabel id="path-select-label">Path</InputLabel>
          <Select labelId="path-select-label" label="Path" value={selectedPathName} onChange={(e) => setSelectedPathName(e.target.value as string)}>
            {paths.map((p) => (
              <MenuItem key={p.id} value={p.name}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!selectedPathName || !pendingPathDrop} onClick={onConfirm}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PathSelectionDialog;
